// @tenorlab/vue-dashboard-pro
// file: src/async-widgets/widget-forex-rates/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { ArrowUp as ComponentIcon } from 'lucide-vue-next'

// Define the metadata object for the plugin
export const WidgetForexRatesMeta: TWidgetMetaInfo = {
  name: 'Forex Rates',
  categories: ['Widget', 'Chart'],
  icon: ComponentIcon,
  noDuplicatedWidgets: true,
  description: 'Displays real-time currency rates (USD pairs).',
  externalDependencies: [],
}
